import { FunctionComponent, useState } from "react";
import { ReactComponent as HamburgerIcon } from '../../../assets/hamburger-black.svg';
import { MobileNavProps } from "src/utils/types/NavigationTypes";
import LogoSection from "../LogoSection";
import MobileMenu from "./MobileMenu";


const MobileNav: FunctionComponent<MobileNavProps> = ({ logoOnly = false }) => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);


  const handleToggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const handleCloseMenu = () => setIsMenuOpen(false);


  return (
    <nav className="w-full flex justify-between items-center px-3 relative md:hidden">
    
      <MobileLogo />
      
      {!logoOnly && (
        <MenuToggle 
          isOpen={isMenuOpen} 
          onToggle={handleToggleMenu} 
          onClose={handleCloseMenu}
        />
      )}
    </nav>
  );
};


const MobileLogo: FunctionComponent = () => (
  <LogoSection />
);


const MenuToggle: FunctionComponent<{
  isOpen: boolean;
  onToggle: () => void;
  onClose: () => void;
}> = ({ isOpen, onToggle, onClose }) => (
  <div>
    <HamburgerButton onClick={onToggle} />
    <MobileMenu isOpen={isOpen} onClose={onClose} />
  </div>
);


const HamburgerButton: FunctionComponent<{ onClick: () => void }> = ({ onClick }) => (
  <div className="cursor-pointer hamburger-button" onClick={onClick}>
    <HamburgerIcon height={30} width={30} />
  </div>
);


export default MobileNav;





